module.exports = __webpack_public_path__ + "media/images/icons/filled/gitlab-122bf57d335ab3a7e44edeecf93ced2d.svg";